import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Tooltip } from "../../../../../Tooltip/index.js";
import { Box } from "../../../../../Box/index.js";
import { useStyles } from "./ToolbarButton.styles.js";
const ToolbarButton = (t0)=>{
    const $ = c(9);
    const { tooltip, onClick, children } = t0;
    const { classes } = useStyles();
    let t1;
    if ($[0] !== onClick) {
        t1 = (event)=>{
            onClick(event);
        };
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    const handleClick = t1;
    let t2;
    if ($[2] !== children || $[3] !== classes.root || $[4] !== handleClick) {
        t2 = /*#__PURE__*/ jsx(Box, {
            className: classes.root,
            onClick: handleClick,
            children: children
        });
        $[2] = children;
        $[3] = classes.root;
        $[4] = handleClick;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2 || $[7] !== tooltip) {
        t3 = /*#__PURE__*/ jsx(Tooltip, {
            title: tooltip,
            placement: "bottom",
            children: t2
        });
        $[6] = t2;
        $[7] = tooltip;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
};
export { ToolbarButton };
